import Navigo from 'navigo';
import { SendAppInitEvent } from '@bark/bark-core/src/helpers/legacy-scripts-support';
import {
	BuyerMessenger,
	BarkBuyerNotifications,
	bugsnagClientNotify,
} from '@bark/bark-core';
import { showChangePasswordModal, useNamespace } from '@bark/bark-core';
import InitiateNewBark from '../helpers/initiate-new-bark';
import { initBuyerAppBranchIO } from "@bark/bark-core/src/helpers/";
import { isOldPHPView } from '../helpers/legacy/legacy-helpers';

export const routerUrl = () => {
	const router = new Navigo('/');

	router.hooks({
		before: async (done) => {
			try {

				BuyerMessenger();

				if (isOldPHPView()) {
					const { FoundationMenuJS } = await import(
						'../components/legacy-foundation-views'
					);

					FoundationMenuJS();
				} else {
					BarkBuyerNotifications();
				}

			} catch (e) {
				console.log(e);
				bugsnagClientNotify(new Error(e.message));
			}
			done();
		},
	});

	router
		.notFound(async () => {
			// called when there is path specified but
			// there is no route matching
		})
		.on('/buyers/messenger/*', async () => {
			await useNamespace([
				'common_activity-log',
				'buyer_messenger',
			]);
			const { BuyerMessengerPage } = await import('../pages');
			await BuyerMessengerPage();
		})
		.on('/buyers/bark/:projectId', async () => {
			await useNamespace([
				'buyer_seller-list_request-quote',
				'common_contact-seller-modal',
				'buyer_seller-list',
				'buyer_create-bark',
				'buyer_create-bark_additional-details',
				'buyer_seller-request-quote',
			]);
			const {
				registerResponseAction,
				registerBulkResponseAction,
				initRequestQuoteFromSellerJs,
				BuyerProjectInteractionTracking,
				initLegacyCreateBark,
			} = await import('@bark/bark-core');
			const { bindRequestQuoteFromAllToWindow } = await import(
				'../components/request-quote/'
			);

			//The buyer next bark stuff needs this code. Basically anywhere that you can create a bark will need it.
			await initLegacyCreateBark();

			if (isOldPHPView()) return;

			// This is just so the seller-list.js code can have access to these functions.
			// That js will be moved into this app, and then we can just import the functions above when we need them.
			window.ResponseActionModule = {
				registerResponseAction,
				registerBulkResponseAction,
			};
			const experimentTracking = BuyerProjectInteractionTracking();
			window.RequestQuoteV2 = initRequestQuoteFromSellerJs({
				experimentTracking,
				source: 'seller-list',
			});
			bindRequestQuoteFromAllToWindow();

			const { SellerListPage } = await import('../pages');
			await SellerListPage();
            initBuyerAppBranchIO(90) ;
		})
		.on('/buyers/dashboard/', async () => {
			await useNamespace(['buyer_project_close-project']);
			const { initLegacyCreateBark, AutofillPostcode } = await import('@bark/bark-core');
			const { ProjectListPage } = await import('../pages');
			ProjectListPage();
			window.AutofillPostcode = AutofillPostcode;
			await initLegacyCreateBark();
			InitiateNewBark().bind();
			if (showChangePasswordModal()) {
				const { runPasswordModal } = await import('@bark/bark-core');
				runPasswordModal();
			} else {
                initBuyerAppBranchIO();
            }
		})
		.on('/:lang/:locale/browse/:categoryId/:browseIdentifier/', async () => {
			const { initLegacyCreateBark, exposeBrowseProjectFunctionsToWindow } = await import(
				'@bark/bark-core'
			);

			await useNamespace(['common_contact-seller-modal', 'buyer_create-bark']);
			await initLegacyCreateBark();
			exposeBrowseProjectFunctionsToWindow();
			SendAppInitEvent('buyer-app');
			const { BrowseListPage } = await import('../pages');
			BrowseListPage();
		})
		.on('/user/notifications', async () => {
			await useNamespace(['buyer_notification-settings', 'common_form-manager']);

			const { NotificationSettings } = await import('../pages');
			NotificationSettings();
		})
		.on('/user/settings', async () => {
			await useNamespace([
				'buyer_account-settings',
				'buyer_camera-modal',
				'common_form-manager',
			]);
			const { AccountDetailsPage } = await import('../pages');
			await AccountDetailsPage();
            initBuyerAppBranchIO();
		})
		.on('/buyers/closed-project/:projectHashedId', async () => {
			const { ClosedBarkReviewPage } = await import('../pages');
			await ClosedBarkReviewPage();
		})
		.on('/buyers/close-project/:projectId', async () => {
			await useNamespace(['buyer_project_close-project']);

			const { CloseBarkPage } = await import('../pages');
			CloseBarkPage();
		})
		.on('/buyers/resubmit-bark/:hashedProjectId/', resubmitJS)
		.on('/buyers/resubmit-instant/:projectId/', resubmitJS)
		.resolve();
};

async function resubmitJS() {
  await useNamespace(['buyer_resubmit-bark']);
	const { ResubmitProjectPage } = await import('../pages');

  ResubmitProjectPage();
}
